import React from 'react';
import BlogPost from './BlogPost';

const RightColumn = () => {
    const blogPosts = [
        {
            title: "We're Live!",
            body: "Got the domain finally, \"www.johnbeltran.com\" :)\n\nNow just need to figre out how to upload audio files...",
            date: "02/01/25",
            locations: [ "Denver, CO" ]
        },
        {
            title: "Starting out",
            body: "Writing web-blog, styling and editing.",
            date: "12/09/24",
            locations: [ "" ]
        }
    ];

    return (
        <div style={{ width: '70%' }}>
            {blogPosts.map((post, index) => (
                <BlogPost key={index} {...post} />
            ))}
        </div>
    );
};

export default RightColumn;